import React from 'react';

const FloatingMenu = ({ children }) => (
  <div className="fixed z-50 flex flex-col items-end space-y-3 bottom-4 right-4">
    {children}
  </div>
);
export default FloatingMenu;
